<!-- eslint-disable -->
<template lang="pug">
    .form(v-if="isAccessToForm")
        .form__container
            .form__title
                | {{ $i18n.t('list.list_common_settings') }}
            form.form__body(
                action="javascript://"
                @submit="submitForm"
                v-if="school && !isLoading"
            )
                .form__field(v-if="!school.studentPayed && !user.isManagerOrSupport")
                    .form__label
                        | {{ $i18n.t('profiles.profiles_profile_accountStatus') }}
                    .form__field-body
                        cs-multiselect.fields__input(
                            :multiple="false",
                            :options="statuses",
                            :show-labels="false",
                            :allow-empty="false",
                            :custom-label="getStatusName",
                            placeholder="",
                            v-model="selectedStatus",
                            :searchable="false"
                        )
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.billing_settings_balance') }}
                    .form__field-body
                        span(v-html="school.account && balanceString")
                .form__field(v-if="user.isSuperadmin")
                    .form__label
                    .form__field-body
                        cs-button(color="blue", pattern="primary-outline", @click.prevent="handleBalanceButtonClick", narrow)
                            | {{ $i18n.t('profiles.profiles_user_buttonChange') }}
                divider
                .form__field
                    .form__label.form__label--bold
                        | {{ $i18n.t('billing.billing_edit_minimalPayment') }}
                    .form__field-body
                template(
                    v-for='course in courseTypes'
                )
                    .form__field
                        .form__label
                            | {{ $i18n.t('common.common_course_' + course) }}
                        .form__field-body
                            cs-input.input-number.input-number--small(
                                :key="course"
                                :error="errors.has(camelCase(course + 'MinPayment'))",
                                type='number',
                                :value='school.account[camelCase(course + \'MinPayment\')]',
                                :name='camelCase(course + \'MinPayment\')',
                                onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                v-validate="'required|max:9|min_value:0'",
                                @input.native="handlePriceInput(camelCase(course + 'MinPayment'), $event.target.value)"
                                :data-vv-as="$i18n.t('billing.billing_edit_minimalPayment').toLowerCase()"
                                step="0.01"
                            )
                template(v-if="!school.forStudentPayedSchools")
                    divider
                    .form__field
                        .table-responsive-container
                            .table-responsive
                                table.forks-table(@wheel='handleScroll($event)')
                                    thead.forks-table__thead
                                        tr.forks-table__row
                                            th.forks-table__column.forks-table__column--separate.forks-table__column--bold(colspan="2")
                                                | {{ $i18n.t('billing.billing_settings_forks') }}
                                            th.forks-table__column(v-for='course in courseTypes')
                                                | {{ $i18n.t('common.common_course_' + course) }}
                                            th.forks-table__column.forks-table__column--last
                                    tbody.forks-table__thead
                                        tr.forks-table__row(v-for='(fork, index) in school.forks')
                                            td.forks-table__column.forks-table__column--x-small
                                                span.forks-table__fork-preview
                                                    | {{ $i18n.t('billing.billing_stocks_from').toLowerCase() }}
                                                    |
                                                    span.forks-table__fork-value {{ fork.left }}
                                                    |
                                                    | {{ $i18n.t('billing.billing_stocks_to').toLowerCase() }}
                                            td.forks-table__column.forks-table__column--small.forks-table__column--separate
                                                cs-input.input-number(
                                                    :value='fork.right',
                                                    type="number"
                                                    @input.stop.native='changeRelativeForks($event, index)',
                                                    :disabled='fork.right === null && fork === school.forks[school.forks.length - 1]'
                                                    :placeholder="$i18n.t('billing.billing_stocks_to')"
                                                    :data-vv-as="$i18n.t('billing.billing_stocks_to').toLowerCase()"
                                                    :name="'rightFork' + index"
                                                    v-validate="`required|min_value:${fork.left + 1}|numeric`",
                                                    :error="errors.has('rightFork' + index)"
                                                )
                                            td.forks-table__column(v-for="(courseType, courseIndex) in courseTypes")
                                                cs-input.input-number(
                                                    type='number'
                                                    @input.stop.native="handlePriceInput('forkPrice', $event.target.value, index, courseType + 'Price')"
                                                    :value="fork[courseType + 'Price']"
                                                    :placeholder="$i18n.t('billing.billing_stocks_price')"
                                                    onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                                    v-validate="'required|max:9|min_value:0|numeric'"
                                                    :name="'coursePriceOfFork' + index + 'Course' + courseIndex"
                                                    :data-vv-as="$i18n.t('billing.billing_stocks_price').toLowerCase()"
                                                    :error="errors.has('coursePriceOfFork' + index + 'Course' + courseIndex)"
                                                    step="0.01"
                                                )
                                            td.forks-table__column.forks-table__column--last
                                                cs-button(
                                                    color="green"
                                                    pattern="primary-outline"
                                                    @click.prevent='removeRange(index)',
                                                    :disabled='school.forks.length <= 2 || index === 0 || index === school.forks.length - 1'
                                                    narrow
                                                )
                                                    svg-icon(name='close', middle='')
                .form__buttons
                    cs-button(color="blue", pattern="primary-outline", @click.prevent='addRange', narrow)
                        svg-icon(name="plus" size="large" slot="icon")
                        | {{ $i18n.t('billing.billing_stocks_addFork') }}
                divider
                .form__buttons
                    cs-button.form__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                        @click="submitForm"
                    )
                        | {{ $i18n.t('homework.homework_create_save') }}
                    cs-button.form__button(
                        color="blue"
                        pattern="primary-outline"
                        @click.prevent="$router.back()"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
                account-balance-modal(v-if="showBalanceModal && user.isSuperadmin",
                                     @close="showBalanceModal = false",
                                     @balance="school.account.balance = Math.round((arguments[0] + school.account.balance) * 100) / 100",
                                     :profile="school"
                )
            cs-loader(v-else)
    div(v-else)
        .content-box.list
            .box-body
                .column.is-12-mobile.list-item.field-column
                    | {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import ListBox from '../lists/ListBox.vue';
    import { mapState } from 'vuex';
    import { camelCase, uniqBy } from 'lodash';
    import SchoolApi from '../../api/school';
    const AccountBalanceModal = () => import("../../modals/AccountBalanceModal.vue");

    export default {
        data() {
            return {
                school: null,
                isLoading: false,
                showBalanceModal: false,
                selectedStatus: "",
                statuses: ['blocked', 'active'],
                statusesNames: {
                    blocked: this.$i18n.t('profiles.profiles_profile_statusBlocked'),
                    active: this.$i18n.t('profiles.profiles_profile_statusActive'),
                },
                courseTypes: [],
            };
        },
        props: {
            id: [Number, String],
        },
        components: {
            ListBox,
            AccountBalanceModal,
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            balanceString () {
                if (this.school.account) {
                    return "<span style='font-weight: bold; line-height: 36px'>" + Math.round(this.school.account.balance * 100) / 100 + "</span>" + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', this.school.account.balance);
                }
                return "";
            },
            isAccessToForm () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
        mounted () {
            this.fetchData();
        },
        watch: {
            selectedStatus (value) {
                if (value === 'blocked') {
                    this.school.account.status = 0;
                } else if (value === 'active') {
                    this.school.account.status = 1;
                }
            }
        },
        methods: {
            fetchData () {
                SchoolApi.getForks(this.id)
                    .then(school => {
                        this.school = school;
                        let courses = uniqBy(this.school.courses, 'type');
                        this.courseTypes = courses.map(course => camelCase(course.type));

                        this.selectedStatus = this.school.account.status ? 'active' : 'blocked';
                        this.isLoading = false;
                    })
                    .catch(err => this.showErrorMessage(err));
            },
            showErrorMessage (err) {
                this.isLoading = false;
                if (err.data) {
                    this.$router.push({ name: 'transactions:list' });
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            handleScroll (event) {
                event = window.event || event;
                let delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
                document.querySelector('.forks-table').scrollLeft -= (delta * 65);
                event.preventDefault();
            },
            handlePriceInput (field, number, forkIndex = undefined, courseTypePrice = undefined) {
                if (!forkIndex && forkIndex !== 0) {
                    this.school.account[field] = Math.round(number * 100) / 100;
                } else {
                    this.school.forks[forkIndex][courseTypePrice] = Math.round(number * 100) / 100;
                }
            },
            cancel() {
                this.$offline ? this.$router.push({name: 'transactions:list'}) : this.$router.back();
            },
            submitForm () {
                this.$validator.validateAll()
                .then((isValid) => {
                    if (isValid) {
                        this.isLoading = true;
                        let form = {
                            forks: this.school.forks,
                            mentalArithmeticMinPayment: this.school.account.mentalArithmeticMinPayment,
                            fastReadingMinPayment: this.school.account.fastReadingMinPayment,
                            onlineSchoolMinPayment: this.school.account.onlineSchoolMinPayment,
                            mathMagicMinPayment: this.school.account.mathMagicMinPayment,
                            memoryDevelopmentMinPayment: this.school.account.memoryDevelopmentMinPayment,
                            multiplicationMinPayment: this.school.account.multiplicationMinPayment,
                            readingEnMinPayment: this.school.account.readingEnMinPayment,
                            russianLanguageMinPayment: this.school.account.russianLanguageMinPayment,
                            status: this.school.account.status,
                        };
                        SchoolApi.updateForks(this.id, form)
                        .then(() => {
                            this.$router.push({name: 'school:profile'});
                        })
                        .catch(err => this.showErrorMessage(err));
                    }
                });
            },
            changeRelativeForks (event, index) {
                this.school.forks[index].right = event.target.value;
                this.school.forks[index + 1].left = Number(event.target.value) + 1;
            },
            addRange () {
                this.school.forks.push({left: null, right: null, mentalArithmeticPrice: 0, fastReadingPrice: 0});
            },
            removeRange (index) {
                if (this.school.forks.length > 2) {
                    this.school.forks.splice(index, 1);
                    this.school.forks[index - 1].right = this.school.forks[index].left - 1;
                }
                if (this.errors && this.errors.items && this.errors.items.length) {
                    this.errors.items.forEach(item => {
                        if (item.field.includes('rightFork')) {
                            item.field = "";
                        }
                    });
                }
            },
            handleBalanceButtonClick () {
                this.showBalanceModal = !this.showBalanceModal;
            },
            getStatusName (status) {
                return this.statusesNames[status];
            },
            camelCase
        }
    }
</script>

<style lang="scss" scoped>
    .input-number {
        &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        -moz-appearance: textfield;
    }

    .input-number--small {
        max-width: 160px;
    }

    .forks-table {
        display: block;
        overflow-x: auto;
        //align-self: center;
        border-collapse: separate;
        border-spacing: 0;
        width: auto;
        &::-webkit-scrollbar-track, &::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        &::-webkit-scrollbar, &::-webkit-scrollbar {
            background-color: #F5F5F5;
            height: 2px;
        }
        &::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb {
            height: 2px;
            background: $color-grey-600;
        }
    }

    .forks-table__row {
        height: 45px;
    }

    .forks-table__thead {
        font-size: 14px;
        line-height: 20px;
    }

    .forks-table__tbody {
        font-size: 16px;
        line-height: 19px;
    }

    .forks-table__column {
        font-weight: normal;
        min-width: 129px;
        text-align: right;
        padding: 4px;
        vertical-align: middle;
    }

    .forks-table__column--small {
        min-width: 100px;
        max-width: 120px;
    }

    .forks-table__column--x-small {
        min-width: 80px;
    }

    .forks-table__column--separate {
        text-align: right;
        padding-right: 16px;
    }

    .forks-table__column--last {
        min-width: 0;
        width: 50px;
        text-align: right;
    }

    .forks-table__column--last .cs-button--narrow {
        height: 45px;
        padding: 12px 15px;
    }

    .forks-table__column--last .cs-button--disabled {
        border: 1px solid #BDBDBD;
        background-color: transparent;
    }

    .forks-table__column--bold {
        font-weight: 500;
    }

    .forks-table__fork-preview {
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
    }

    .forks-table__fork-value {
        font-weight: 500;
    }

    .table-responsive-container {
        display: grid;
    }

    .table-responsive {
        overflow-x: auto;
    }

</style>

<style lang="scss" scoped>
    @import '@/assets/sass/forms/form.scss';

    .form__textarea {

        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        box-shadow: inset 0 1px 2px hsla(0,0%,4%,.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 180px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .fields__element_date {
        @include media($xlg) {
            display: flex;
            align-items: baseline;
        }
    }

    .fields__element--period {
        display: flex;
        flex-direction: row;
        align-items: center;
        @include stack-space($space-base);
        @include media($xlg) {
            padding: 0;
        }
    }

    .fields__divider {
        text-align: center;
        margin: 0 $space-x-small;
    }
</style>
